import { useRuntimeConfig, useScriptIntercom } from '#imports'

import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { IntercomConfig } from '../types/intercom.types'
import {
  withEnhancedLoad,
  withIntercomAvailabilityGuard,
} from '../utils/intercom'

export function useIntercom(settings: Partial<IntercomConfig> = {}) {
  const { INTERCOM_APP_ID } = useRuntimeConfig().public

  const intercomDefaultSettings: IntercomConfig = {
    app_id: INTERCOM_APP_ID,
    api_base: 'https://api-iam.eu.intercom.io',
    hide_default_launcher: true,
    region: 'eu',
    // The Contact type attribute should be removed with CAPLA-2417
    'Contact type': 'CUSTOMER',
    scriptOptions: {
      trigger: 'manual',
    },
  }

  if (import.meta.client && !isEmpty(settings)) {
    window.intercomSettings = {
      ...intercomDefaultSettings,
      ...settings,
    }
  }

  const { proxy, ...instance } = useScriptIntercom({
    ...intercomDefaultSettings,
    ...settings,
  })

  return {
    ...instance,
    intercom: withIntercomAvailabilityGuard(),
    load: withEnhancedLoad(instance.load),
  }
}
